import { render, staticRenderFns } from "./trainingModulePageDashboardSingle8.vue?vue&type=template&id=3b9f307b&scoped=true&"
import script from "./trainingModulePageDashboardSingle8.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageDashboardSingle8.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageDashboardSingle8.vue?vue&type=style&index=0&id=3b9f307b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f307b",
  null
  
)

export default component.exports